var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 105,
    viewBox: "0 0 105 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 52.5C0 23.5051 23.5051 0 52.5 0C81.4949 0 105 23.5051 105 52.5C105 81.4949 81.4949 105 52.5 105C23.5051 105 0 81.4949 0 52.5ZM57 82.5C57 84.9853 54.9853 87 52.5 87C50.0147 87 48 84.9853 48 82.5L48 38.5C48 36.0147 50.0147 34 52.5 34C54.9853 34 57 36.0147 57 38.5L57 82.5ZM52.5 31C54.9853 31 57 28.9853 57 26.5V22.5C57 20.0147 54.9853 18 52.5 18C50.0147 18 48 20.0147 48 22.5V26.5C48 28.9853 50.0147 31 52.5 31Z",
    fill: "#e2e8f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b21f12b490d0f7e45a09b66fb5c8f655.svg";
export { ForwardRef as ReactComponent };